<template>
  <div class="container-fluid">
    <listing-action
        :deleteHandler="deleteRecords"
        :createHandler="createRecord"
    ></listing-action>
    <search-items v-model="params.search" :searchHandler="searchTemplate" :placeholder="'Type to search'"></search-items>
    <b-table
        :items="fields"
        :fields="headers"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        @sort-changed="sortingChanged"
        sort-icon-left
    >
      <template #cell(id)="{item}">
          <b-form-checkbox
              :id="'checkbox_'+item.id"
              v-model="checkbox"
              name="checkbox-1"
              :value="item.id"
              unchecked-value="not_accepted"
          >
          </b-form-checkbox>
      </template>
      <template #cell(actions)="item">
        <router-link :to="{path:'/yearly-planner-events/'+item.item.id+'/view'}"><eye class="mr-2" fillColor="#009FE3" /></router-link>
        <edit class="delete_step ml-2" @click="editYearlyPlannerTemplate(item.item)" fillColor="#009FE3" />
        <delete class="delete_step ml-2" @click="deleteYearlyPlannerTemplate(item.item.id)" fillColor="#E30000" />
      </template>
    </b-table>

    <b-pagination
        v-model="pagination.currentPage"
        :total-rows="pagination.rows"
        :per-page="pagination.perPage"
        aria-controls="itemList"
        align="center"
        @change="handlePagination"
        v-if="pagination.total > 0"
    ></b-pagination>

    <b-modal id="addTemplateModal" size="sm" no-close-on-backdrop  hide-footer>
      <template #modal-title>
        <span>Yearly Planner Template</span>
      </template>
      <div class="row">
        <div class="col-md-12">
          <b-form-group
              label="Template Name"
              labelClass="required"
          >
            <b-form-input
                type="text"
                placeholder="Name"
                v-model="form.name"
                name="name"
                v-validate="{required: true}"
            ></b-form-input>
            <div v-if="errors && errors.first('name')" class="error_msg">
              The name field is required
            </div>
          </b-form-group>
        </div>

        <div class="col-12 text-right mt-3">
          <b-button variant="primary" @click="saveYearlyPlannerTemplate">Save</b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import Delete from 'vue-material-design-icons/Delete';
import Edit from 'vue-material-design-icons/CircleEditOutline';
import Eye from "vue-material-design-icons/Eye.vue";
import { http } from "@/config/httpCommon"
import {getLastPage, getPageModal, removePageModal, setPageModal} from "@/helpers/Helpers";
import SearchItems from "@/components/SearchItems.vue";

export default {
  components: {
    Delete,
    Edit,
    Eye,
    SearchItems
  },
  async created(){
    this.$store.commit('set', ['showLoader', true]);
    this.preservePaginationIgnoreSearch('page', 'search', this.$route.name, this.getYearlyPlannerTemplates);
    this.$store.commit('set', ['showLoader', false]);
  },
  data(){
    return {
      yearly_planner_templates: [],
      fields: [],
      form: {
        id: 0,
        name: ''
      },
      checkbox: [],
      base_url: process.env.VUE_APP_FILE_URL,
      headers: [
        {key: 'id', label: '',sortable: false},
        {key: 'name', label: 'Template Name',sortable: true},
        {key: 'events_count', label: 'Total Events',sortable: true},
        {key: 'actions', label: 'Actions',},
      ],
      pagination:{
        rows:null,
        currentPage:null,
        perPage:null,
        total:0
      },
      sortBy: 'name', //Field key for sorting by (or null for no sorting
      sortDesc: true,
      params: {
        sortBy: '', //Field key for sorting by (or null for no sorting
        sortOrder: false, // true if sorting descending, false otherwise
        search:'',
        page : 1,
      }
    }
  },
  computed: {
    getSortOrder() {
      return this.sortDesc ? 'DESC' : 'ASC'
    },
    getSortField() {
      return this.sortBy
    },
  },
  methods:{
    sortingChanged() {
      this.getYearlyPlannerTemplates()
    },
    searchTemplate(){
      this.params.page = 1;
      setPageModal(1,this.$route.name,this.params);
      this.getYearlyPlannerTemplates();
    },
    async getYearlyPlannerTemplates() {
      this.$store.commit('set', ['showLoader', true]);
      //make params
      this.params.sortBy = this.getSortField
      this.params.sortOrder = this.getSortOrder
      let params = new URLSearchParams(this.params);
      setPageModal(this.params.page,this.$route.name,this.params);
      params = '?'+params.toString();
      let res = await http.get(`yearly-planner-template`+params);
      this.yearly_planner_templates = res.data.data
      this.$store.commit('set', ['showLoader', false]);
      this.fields = this.yearly_planner_templates;
      this.makePagination(res.data);
    },
    async handlePagination(page=''){
      this.params.page = page
      setPageModal(page,this.$route.name,this.params);
      this.getYearlyPlannerTemplates();
    },
    makePagination(data){
      this.pagination.currentPage = data.meta.current_page;
      this.pagination.rows = data.meta.total;
      this.pagination.perPage = data.meta.per_page;
      this.pagination.total = data.meta.total;
    },
    ResetForm(){
      this.$bvModal.show("addTemplateModal");
    },
    async saveYearlyPlannerTemplate(){
      let valid = await this.$validator.validate();
      if(valid){
        try {
          this.$store.commit('set', ['showLoader', true]);


          if(this.form.id > 0){
              await http.patch(`yearly-planner-template/${this.form.id}`, this.form);
          }else{
              await http.post(`yearly-planner-template`, this.form);
          }
          this.$store.commit('set', ['showLoader', false]);
          this.$bvModal.hide("addTemplateModal");
          // await this.getYearlyPlannerTemplates()
          this.fields = this.yearly_planner_templates;
          if(this.form.id > 0){
            this.preservePagination( 'page', 'search', this.$route.name, this.getYearlyPlannerTemplates)
          }else{
            this.nextPageOnCreation('page','search', this.fields.length - 1, this.pagination.perPage, this.pagination.currentPage, getLastPage(this.pagination.perPage ,this.pagination.total ), this.$route.name, this.getYearlyPlannerTemplates);
          }
          this.showToast('Yearly planner template saved successfully','SUCCESS')
        }catch (err){
          this.$store.commit('set', ['showLoader', false]);
          this.showError(err);
        }
      }
    },
    createRecord(){
      this.form.id = 0;
      this.form.name = '';
      this.$bvModal.show("addTemplateModal");
    },
    async deleteRecords(){
      if(this.checkbox.length > 0){
        try {
          let payload = {
            ids: this.checkbox
          }
          this.$confirm('Template/s will be deleted with its events. Are you sure to delete?').then(async ()=>{
            this.$store.commit('set', ['showLoader', true]);
            await http.delete(`yearly-planner-template/1`,{data:  payload });
            this.showToast('Templates deleted successfully','SUCCESS')

            payload.ids.forEach(id => {
              let index = this.yearly_planner_templates.findIndex(item => item.id == id);
              this.yearly_planner_templates.splice(index, 1);
            });
            this.previousPageOnDeletion('page','search',this.fields.length,this.$route.name,this.getYearlyPlannerTemplates);
            this.$store.commit('set', ['showLoader', false]);
            this.checkbox = [];
          }).catch(_ => {
            console.log(_);
          })
        }catch (e) {
          this.$store.commit('set', ['showLoader', false]);
          this.showErrors(e);
        }
      }else{
        this.showToast('Atleast select 1 template', 'DANGER');
      }
    },
    async deleteYearlyPlannerTemplate(id){
      try {
        this.$confirm('Template will be deleted with its events. Are you sure to delete?').then(async ()=>{
          this.$store.commit('set', ['showLoader', true]);
          let payload = {
            ids: [id]
          }
          await http.delete(`yearly-planner-template/1`,{data:  payload });
          this.showToast('Template deleted successfully','SUCCESS')
          payload.ids.forEach(id => {
            let index = this.yearly_planner_templates.findIndex(item => item.id == id);
            this.yearly_planner_templates.splice(index, 1);
          });
          this.previousPageOnDeletion('page','search',this.yearly_planner_templates.length,this.$route.name,this.getYearlyPlannerTemplates);
          this.$store.commit('set', ['showLoader', false]);
        }).catch(_ => {
          console.log(_);
        })
      }catch (e) {
        this.showErrors(e);
        this.$store.commit('set', ['showLoader', false]);
      }
    },
    editYearlyPlannerTemplate(item){
      this.form.id = item.id;
      this.form.name = item.name;
      this.$bvModal.show("addTemplateModal");
    }
  }
}
</script>
<style lang="scss" scoped>
.add_field_btn{
  width: 125px;
  .float-right{
    line-height: 0;
  }
}
.delete_addons, .edit_addons{
  cursor: pointer;
}
.img-thumbnail{
  width: 200px;
}
</style>
